import React, { createContext, useContext, useMemo, useState } from 'react';

type CollectorSelectionType = {
  collectorsSelectionStatus: string;
  setCollectorsSelectionStatus: React.Dispatch<React.SetStateAction<string>>;
};

export const CollectorSelectionContext = createContext<CollectorSelectionType | null>(
  null
);

export const useCollectorSelectionContext = (): CollectorSelectionType => {
  const val = useContext(CollectorSelectionContext);
  if (!val) {
    throw new Error(
      'useCollectorSelectionContext must be called within a CollectorSelectionContextProvider'
    );
  }
  return val;
};

const CollectorSelectionContextProvider: React.FC = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const [collectorsSelectionStatus, setCollectorsSelectionStatus] = useState(
    'collectors.all'
  );

  const value = useMemo(() => {
    return {
      collectorsSelectionStatus,
      setCollectorsSelectionStatus
    };
  }, [collectorsSelectionStatus]);

  return (
    <CollectorSelectionContext.Provider value={value}>
      {children}
    </CollectorSelectionContext.Provider>
  );
};

export default CollectorSelectionContextProvider;
